import React from "react";
import Person from "../person";
import MultiplePerson from "../multiplePerson";
import TotCount from "../totCount";
import classes from "./style.module.scss";
import cx from "classnames";
import _ from "lodash";
import Host from "../../../../assets/images/tot/Host-3.png";

const Calculate = ({
  finalGuessWords,
  finalSkippedWords,
  game_over = false
}) => (
  <p className={cx("text-center", classes.calculate)}>
    {game_over ? (
      <span className={cx("text", classes.scoreText)}>Final Score:</span>
    ) : (
      <span className={cx("text", classes.scoreText)}>Score:</span>
    )}
    <div className="calculate-scrores">
      {/* <div className={cx(classes.clWrap)}> */}
      <div className="guesses-score">
        <span className="score-text s-text">Guessed</span>
        <span className="s-number">
          {finalGuessWords ? finalGuessWords.length : 0}
        </span>{" "}
      </div>
      <span className="text equal">-</span>{" "}
      <div className="skipped-score">
        <span className="score-text s-text">Skipped</span>
        <span className="s-number">
          {finalSkippedWords ? finalSkippedWords.length : 0}
        </span>
      </div>
      {/* </div> */}
      <span className="text equal">=</span>{" "}
      <div className="total-score">
        <span className="score-text s-text">Score:</span>
        <span className={cx("s-number", classes.clResult)}>
          {finalGuessWords &&
          finalSkippedWords &&
          finalGuessWords.length - finalSkippedWords.length > 0
            ? finalGuessWords.length - finalSkippedWords.length
            : 0}
        </span>
      </div>
    </div>
  </p>
);

const FinalScoreCard = ({
  finalScoreLabel,
  guessedLabel,
  skippedLabel,
  skippedWords,
  guessedWords,
  activeGuesser,
  players_with_max_score
}) => {
  guessedLabel = _.capitalize(guessedLabel) || "Guessed";
  skippedLabel = _.capitalize(skippedLabel) || "Skipped";
  return (
    <>
      {/* // <div className="h-100 d-flex justify-content-between py-3"> */}
      {/* <h2 className={cx("text text-center", classes.mainTitle)}>
        {finalScoreLabel}
      </h2>
      <div className="mb-4">
        <div
          className={cx(
            "d-flex justify-content-between mx-auto",
            classes.guessSkipWrap
          )}
        >
          <div>
            <p className={cx("text-gr-green", classes.gsTitle)}>
              {guessedLabel}
            </p>
            <TotCount value={guessedWords.length} />
          </div>
          <div>
            <p className={cx("text-gr-yellow", classes.gsTitle)}>
              {skippedLabel}
            </p>
            <TotCount color="yellow" value={skippedWords.length} />
          </div>
        </div>
      </div> */}
      <div className="text-center d-flex flex-column justify-content-end">
        {players_with_max_score.length > 1 ? (
          <MultiplePerson
            color="yellow"
            imageClassName={classes.personImage}
            // activeGuesser={activeGuesser}
            players_with_max_score={players_with_max_score}
          />
        ) : (
          <Person
            color="yellow"
            imageClassName={classes.personImage}
            // activeGuesser={activeGuesser}
            mvp={true}
            players_with_max_score={players_with_max_score}
          />
        )}
      </div>
      <div className="calculate-wrapper">
        <div className="calculate-content">
          <h1>Game Over!</h1>
          <Calculate
            finalGuessWords={guessedWords}
            finalSkippedWords={skippedWords}
            game_over={true}
          />
        </div>
      </div>
      {/* </div> */}
    </>
  );
};
const GusserCard = ({
  activeGuesser,
  guesserLabel,
  screenParams,
  finalSkippedWords,
  finalGuessWords,
  players_with_max_score
}) => {
  return (
    <>
      {/* <h2 className={cx("text", classes.gusserTitle)}>{guesserLabel}</h2> */}
      <div className="text-center d-flex flex-column justify-content-end">
        <Person
          color="yellow"
          imageClassName={classes.personImage}
          activeGuesser={activeGuesser}
          // mvp={true}
          // players_with_max_score={players_with_max_score}
        />
      </div>
      <div className="calculate-wrapper">
        <div className="calculate-content">
          <h1>Round Over!</h1>
          <Calculate
            finalGuessWords={finalGuessWords}
            finalSkippedWords={finalSkippedWords}
          />
        </div>
      </div>
    </>
  );
};

const FinalScore = (props) => {
  const {
    guesser = false,
    screenParams,
    activeGuesser,
    roomObj,
    player_score
  } = props;

  const roundOverLabel =
    _.get(screenParams, "tot.resultround_banner_text") || "ROUND OVER!";
  const gameOverLabel =
    _.get(screenParams, "tot.over_banner_text") || "Game Over!";
  const finalScoreLabel =
    _.get(screenParams, "tot.over_final-score_label") || "FINAL SCORE";
  const guesserLabel =
    _.get(screenParams, "tot.guessing_guesser_label") || "Guesser";
  const guessedLabel = _.get(screenParams, "tot.guessed_label") || "GUESSED";
  const skippedLabel = _.get(screenParams, "tot.skipped_label") || "SKIPPED";

  const guessedWords = _.get(roomObj, "game_state.right_words") || [];
  const skippedWords = _.get(roomObj, "game_state.skipped_words") || [];
  const gusserGifImage = _.get(screenParams, "tot.resultround_gif") || "";
  const finalGifImage = _.get(screenParams, "tot.over_gif") || "";
  const activePlayerID =
    activeGuesser && activeGuesser.player_id ? activeGuesser.player_id : 0;

  let finalGuessWords = guessedWords.filter(
    (word) => word.player_id === activePlayerID
  );
  let finalSkippedWords = skippedWords.filter(
    (word) => word.player_id === activePlayerID
  );

  let players_with_max_score = [];
  let max_score = 0;
  player_score &&
    player_score.forEach((item) => {
      if (item.score > max_score) {
        max_score = item.score;
        players_with_max_score = [];
        players_with_max_score.push(item);
      } else if (item.score === max_score) {
        players_with_max_score.push(item);
      }
    });
  players_with_max_score.sort((a, b) => {
    return a.player_id - b.player_id;
  });
  return (
    <div className="tot-50 pb-0">
      <div className="tot-final-score h-100">
        {/* <div className="over-col">
          <p className="text-yellow over-text">
            {guesser ? roundOverLabel : gameOverLabel}
          </p>
        </div> */}
        <div className="result-col">
          <div className="tot-results-row">
            {guesser ? (
              <GusserCard
                activeGuesser={activeGuesser}
                screenParams={screenParams}
                guesserLabel={guesserLabel}
                finalGuessWords={finalGuessWords}
                finalSkippedWords={finalSkippedWords}
              />
            ) : (
              <FinalScoreCard
                finalScoreLabel={finalScoreLabel}
                guessedLabel={guessedLabel}
                skippedLabel={skippedLabel}
                activeGuesser={activeGuesser}
                guessedWords={guessedWords}
                skippedWords={skippedWords}
                players_with_max_score={players_with_max_score}
              />
            )}
            <div className="final-host">
              <img
                // src={guesser ? gusserGifImage : finalGifImage}
                src={Host}
                alt=""
              />
            </div>
          </div>
        </div>
        {/* <div className="gif-col">
          <img
            className="gif-img"
            src={guesser ? gusserGifImage : finalGifImage}
            alt=""
          />
        </div> */}
      </div>
    </div>
  );
};

export default FinalScore;
